import React from "react";

const AppContext = React.createContext({
    currentPage: 'Welcome'
});

export default AppContext;